import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_submitted_surveys_grid_ComponentContextService } from './FootprintManager.submitted_surveys_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Surveys_date_filter_dd_singleComponent } from './Surveys.date_filter_dd_single.component'


interface IFootprintManager_submitted_surveys_gridComponentEntity {
  Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, SurveyDefinition_Name?: string, OperationContextType_Name?: string, ContextAppointment_LookupCode?: string, ContextLicensePlate_LookupCode?: string, ContextLocation_Name?: string, ContextProject_LookupCode?: string, ContextShipment_LookupCode?: string, ContextShippingContainer_LookupCode?: string, ContextTask_Id?: number, ContextTask_OperationCode_Name?: string, Equipment_Name?: string}

interface IFootprintManager_submitted_surveys_gridComponentInParams {
  entities?: { type?: string, ids?: number[] }[], operationContextTypes?: string[], warehouseIds?: number[]}


class FootprintManager_submitted_surveys_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_submitted_surveys_gridComponent;
  entity: IFootprintManager_submitted_surveys_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    survey_definition: null,
    entity: null,
    operation_context_type: null,
    created_on: null,
    created_by: null,
    completed_on: null,
    completed_by: null,
    equipment: null,
  }



  constructor(
    grid: FootprintManager_submitted_surveys_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.survey_definition = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.survey_definition,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.entity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.entity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.operation_context_type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.operation_context_type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.completed_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.completed_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.completed_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.completed_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.equipment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.equipment,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_submitted_surveys_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_submitted_surveys_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      entities:  $grid.inParams.entities as { type: string, ids: number[]}[] ,
      operationContextTypes:  $grid.inParams.operationContextTypes ,
      dates:  $grid.vars.dates as { dateFilter: string, fromDate: string, toDate: string} ,
      warehouseIds:  $grid.inParams.warehouseIds ,
    };
    const data = await this.$datasources.Surveys.ds_submitted_surveys_grid_temp.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_submitted_surveys_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.survey_definition.displayControl as TextModel).text = `${$row.entity.SurveyDefinition_Name} #${$row.entity.Id}`;
    (this.cells.operation_context_type.displayControl as TextModel).text = $row.entity.OperationContextType_Name;
    (this.cells.created_on.displayControl as TextModel).text = $row.entity.CreatedSysDateTime.toString();
    (this.cells.created_by.displayControl as TextModel).text = $row.entity.CreatedSysUser;
    (this.cells.completed_on.displayControl as TextModel).text = $row.entity.ModifiedSysDateTime?.toString();
    (this.cells.completed_by.displayControl as TextModel).text = $row.entity.ModifiedSysUser;
    (this.cells.equipment.displayControl as TextModel).text = $row.entity.Equipment_Name;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'survey_definition' : {
        this.on_survey_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_submitted_surveys_gridComponentRowModel,
  $grid: FootprintManager_submitted_surveys_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let format = `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.trim().toUpperCase() === '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  if ($utils.isDefined(format)) {
      $row.cells.created_on.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, format);
      $row.cells.completed_on.displayControl.text = $utils.date.format($row.entity.ModifiedSysDateTime, format);
  }
  }
  on_survey_clicked(event = null) {
    return this.on_survey_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_survey_clickedInternal(
    $row: FootprintManager_submitted_surveys_gridComponentRowModel,
  $grid: FootprintManager_submitted_surveys_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  $shell.FootprintManager.opensingle_survey_hubDialog({ surveyId: $row.entity.Id }, 'flyout',EModalSize.Large );
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Surveys_date_filter_dd_singleComponent),
  ],
  selector: 'FootprintManager-submitted_surveys_grid',
  templateUrl: './FootprintManager.submitted_surveys_grid.component.html'
})
export class FootprintManager_submitted_surveys_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_submitted_surveys_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_submitted_surveys_gridComponentInParams = { entities: [], operationContextTypes: [], warehouseIds: [] };


  //#region Variables
  vars: { dates?: { dateFilter?: string, fromDate?: string, toDate?: string } } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     survey_definition: new GridHeaderModel(new HeaderStyles(null, null), 'survey_definition', 'Survey', false, false, null, false),       entity: new GridHeaderModel(new HeaderStyles(null, null), 'entity', 'Entity', false, false, null, false),       operation_context_type: new GridHeaderModel(new HeaderStyles(null, null), 'operation_context_type', 'Operation type', false, false, null, false),       created_on: new GridHeaderModel(new HeaderStyles(null, null), 'created_on', 'Created on', false, false, null, false),       created_by: new GridHeaderModel(new HeaderStyles(null, null), 'created_by', 'Created by', false, false, null, false),       completed_on: new GridHeaderModel(new HeaderStyles(null, null), 'completed_on', 'Completed on', false, false, null, false),       completed_by: new GridHeaderModel(new HeaderStyles(null, null), 'completed_by', 'Completed by', false, false, null, false),       equipment: new GridHeaderModel(new HeaderStyles(null, null), 'equipment', 'Equipment', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_submitted_surveys_gridComponentRowModel[] = [];

  @Input('entities') set $inParams_entities(value: any) {
    this.inParams['entities'] = value;
  }
  get $inParams_entities(): any {
    return this.inParams['entities'] ;
  }
  @Input('operationContextTypes') set $inParams_operationContextTypes(value: any) {
    this.inParams['operationContextTypes'] = value;
  }
  get $inParams_operationContextTypes(): any {
    return this.inParams['operationContextTypes'] ;
  }
  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    date_filter: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    from_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    to_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    date_filter: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['date_filter'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Date filter', false, false),
    from_date: new FieldModel(new DateBoxModel(this.formGroup.controls['from_date'] as DatexFormControl, null, false, false, '', 'date', null)
, new ControlContainerStyles(null, null), 'From', false, false),
    to_date: new FieldModel(new DateBoxModel(this.formGroup.controls['to_date'] as DatexFormControl, null, false, false, '', 'date', null)
, new ControlContainerStyles(null, null), 'To', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Submitted surveys';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;

    (this.filters.date_filter.control as SelectBoxModel).reset('modifiedSysDateTime');

    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['date_filter']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_filter_changed();
      });
    this.formGroup
      .controls['from_date']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_filter_changed();
      });
    this.formGroup
      .controls['to_date']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_filter_changed();
      });

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      entities:  $grid.inParams.entities as { type: string, ids: number[]}[] ,
      operationContextTypes:  $grid.inParams.operationContextTypes ,
      dates:  $grid.vars.dates as { dateFilter: string, fromDate: string, toDate: string} ,
      warehouseIds:  $grid.inParams.warehouseIds ,
    };
    try {
      const data = await this.$datasources.Surveys.ds_submitted_surveys_grid_temp.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_submitted_surveys_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_submitted_surveys_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_submitted_surveys_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if (!$grid.rows.find(row => row.entity.CreatedSysDateTime !== row.entity.ModifiedSysDateTime)) {
      $grid.headers.created_by.hidden = true;
      $grid.headers.created_on.hidden = true;
  
      // If no variance between created / completed date, lock down date type filter
      $grid.filters.date_filter.control.readOnly = true;
      $grid.filters.date_filter.control.value = 'modifiedSysDateTime';
  }
  else {
      $grid.headers.created_by.hidden = false;
      $grid.headers.created_on.hidden = false;
  }
  
  // Set the entity name
  let result = (await $flows.Surveys.get_survey_context_details_flow({ surveyIds: $grid.rows.map(row => row.entity.Id)}));
  
  $grid.rows.forEach(row => {
      let entity = result.entities.find(entity => entity.surveyId === row.entity.Id);
      row.cells.entity.displayControl.text = `${entity.type} ${entity.name}`;
  });
  
  // Format the username
  $grid.rows.forEach(async row => {
      row.cells.completed_by.displayControl.text = (await $flows.Utilities.format_username_flow({inUserName: row.entity.ModifiedSysUser})).outUserName ?? row.entity.ModifiedSysUser;
  });
  
  $grid.rows.forEach(async row => {
      row.cells.created_by.displayControl.text = (await $flows.Utilities.format_username_flow({inUserName: row.entity.CreatedSysUser})).outUserName ?? row.entity.CreatedSysUser;
  })
  
  $grid.on_filter_changed();
  }
  on_filter_changed(event = null) {
    return this.on_filter_changedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_filter_changedInternal(
    $grid: FootprintManager_submitted_surveys_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_submitted_surveys_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($grid.filters.date_filter.control.value) && ($utils.isDefined($grid.filters.from_date.control.value) || $utils.isDefined($grid.filters.to_date.control.value))) {
      $grid.vars.dates = {
          dateFilter: $grid.filters.date_filter.control.value,
          fromDate: $grid.filters.from_date.control.value,
          toDate: $grid.filters.to_date.control.value
      };
  }
  else {
      $grid.vars.dates = null;
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
